import request from '@/utils/request'

export function getAdmin(params) {
  return request({
    url: '/admin/common/getAdmin',
    method: 'get',
    params: params
  })
}

//获取容联登录的token
export function rongLianToken(params) {
  return request({
    url: '/admin/common/rongLianToken',
    method: 'get',
    params: params
  })
}


//店铺创建子账号

export function addChildAdmin(data) {
  return request({
    url: '/admin/common/addChildAdmin',
    method: 'post',
    data: data
  })
}


export function qlStoreAdmin(data) {
  return request({
    url: '/admin/common/qlStoreAdmin',
    method: 'post',
    data: data
  })
}












// WEBPACK FOOTER //
// ./src/api/storeAdmin.js